import { type FC, type ReactNode } from 'react';
import { CssBaseline } from '@material-ui/core';
import {
  createGenerateClassName,
  jssPreset,
  StylesProvider,
  type Theme,
  ThemeProvider,
} from '@material-ui/core/styles';
import { create } from 'jss';

import { getAppEnv } from 'src/lib/env';

const generateClassName = createGenerateClassName({
  disableGlobal: getAppEnv() !== 'development',
});

const jss = create({
  ...jssPreset(),
  insertionPoint: 'jss-insertion-point',
});

interface Props {
  theme: Theme;
  children: ReactNode;
}

export const ThemeAndStylesProvider: FC<Props> = ({ theme, children }) => {
  return (
    <ThemeProvider theme={theme}>
      <StylesProvider
        generateClassName={generateClassName}
        jss={jss}
      >
        <CssBaseline />

        {children}
      </StylesProvider>
    </ThemeProvider>
  );
};
